import { useRef } from 'react';
import {
  AlertDialog, AlertDialogBody, AlertDialogFooter,
  AlertDialogHeader, AlertDialogContent, AlertDialogOverlay,
  Button,
} from '@chakra-ui/react';

export default function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title = 'Are you sure?',
  message,
  confirmLabel = 'Delete',
  colorScheme = 'red',
}) {
  const cancelRef = useRef();

  function handleConfirm() {
    onConfirm();
    onClose();
  }

  return (
    <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose} isCentered size="sm">
      <AlertDialogOverlay backdropFilter="blur(2px)">
        <AlertDialogContent borderRadius="16px" boxShadow="0 20px 60px rgba(0,0,0,0.18)">
          <AlertDialogHeader fontSize="16px" fontWeight={700} pb={1}>
            {title}
          </AlertDialogHeader>
          <AlertDialogBody fontSize="14px" color="gray.600">
            {message}
          </AlertDialogBody>
          <AlertDialogFooter gap={2}>
            <Button ref={cancelRef} variant="ghost" size="sm" color="gray.500" onClick={onClose}>
              Cancel
            </Button>
            <Button colorScheme={colorScheme} size="sm" fontWeight={600} onClick={handleConfirm}>
              {confirmLabel}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}
